<template>
  <layout-vendor-dashboard-inner :vendor-id="vendorId">
    <div class="vendor-dashboard-inner" style="min-height: 400px">
      <div class="action-cards">
        <card class="quick-actions" title="justopp.companyActionsWidget.title">
          <div class="quick-actions__wrapper">
            <saffron-link
              v-for="quickAction in quickActions"
              :key="quickAction.component"
              class="flex c-text plain"
              :to="{ name: quickAction.component, params: quickActions.params }">
              <div class="quick-actions__action flex-middle gap-m">
                <icon-halo
                  class="inline-block"
                  halo-theme="lead"
                  theme="bg"
                  :icon="quickAction.icon"
                  :size="2"></icon-halo>
                <span class="text-semibold inline-block">{{
                  translateUcFirst(quickAction.label)
                }}</span>
              </div>
            </saffron-link>
          </div>
        </card>
        <card title="justopp.dealLogistics.title">
          <div class="flex flex-wrap flex-stretch gap-m">
            <div class="quick-action flex-middle flex-center gap-m">
              <h4>Coming soon...</h4>
            </div>
          </div>
        </card>
        <card class="flex-column" title="justopp.activeDealsWidget.title">
          <template #body>
            <div class="card__body active-deals-widget">
              <active-deals
                :vendor-id="vendorId"
                :link-to="{
                  name: 'company-vendorId-dashboard-products',
                  params: { vendorId },
                }" />
            </div>
          </template>
        </card>
        <card class="flex-column" title="justopp.recentBidsWidget.title">
          <template #body>
            <div class="card__body bids-widget">
              <our-bids
                :link-to="{
                  name: 'company-vendorId-dashboard-bids',
                  params: { vendorId },
                }"
                :constant-filters="{
                  VendorId: vendorId,
                }" />
            </div>
          </template>
        </card>
        <card class="flex-column" title="justopp.recentOrdersWidget.title">
          <template #body>
            <div class="card__body orders-widget">
              <our-orders
                :link-to="{
                  name: 'company-vendorId-dashboard-orders',
                  params: { vendorId },
                }"
                :vendor-id="vendorId" />
            </div>
          </template>
        </card>
      </div>
    </div>
  </layout-vendor-dashboard-inner>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import OurBids from "@/client/applications/justopp/components/widgets/OurBids.vue";
import ActiveDeals from "@/client/applications/justopp/components/widgets/ActiveDeals.vue";
import OurOrders from "@/client/applications/justopp/components/widgets/OurOrders.vue";

export default {
  components: {
    OurBids,
    ActiveDeals,
    OurOrders,
  },
  layout: {
    component: "noContainer",
    params: {
      title: "justopp.vendorDashboard.pageTitle",
      subTitle: "justopp.vendorDashboard.pageSubtitle",
      containerClass: "margin-remove-vertical",
    },
  },
  middleware: {
    requireVendorOrAdmin: { vendorIdFromParam: "vendorId" },
  },
  props: {
    // vendor ID
    vendorId: {
      type: String,
      default: 0,
    },
  },
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();

    console.log(props.vendorId);

    const quickActions = [
      {
        component: "user-dashboard-profile",
        label: "justopp.companyActionsWidget.actions.personalProfile",
        icon: "user",
      },
      {
        component: "company-vendorId-dashboard-products-create",
        label: "justopp.companyActionsWidget.actions.createDeal",
        params: { vendorId: props.vendorId },
        icon: "bag-plus",
      },
      {
        component: "company-vendorId-dashboard-manageUsers",
        label: "justopp.companyActionsWidget.actions.manageUsers",
        params: { vendorId: props.vendorId },
        icon: "users",
      },
      {
        component: "company-vendorId-dashboard-statistics",
        label: "justopp.companyActionsWidget.actions.statistics",
        params: { vendorId: props.vendorId },
        icon: "chart-bar",
      },
    ];

    return { asyncOps, asyncOpsReady, asyncStatus, quickActions };
  },
  meta: "justopp.vendorDashboard.browserTitle",
  data() {
    return {
      asyncData: {},
    };
  },
  computed: {},
  watch: {},
  methods: {
    logout() {
      this.$store.commit("user/logout");
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style lang="scss" scoped>
.action-cards {
  display: flex;
  flex-wrap: wrap;
  gap: var(--margin-2xl);
  flex-wrap: wrap;

  > * {
    flex: 0 0 calc(50% - var(--margin-2xl) / 2);
    @media (max-width: 1024px) {
      flex: 0 0 100%;
    }
  }
}

.quick-actions {
  &__wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: var(--margin-l);

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }
}

.active-deals-widget,
.orders-widget,
.bids-widget {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;

  & > :deep(.content) {
    flex: 1 1 auto;

    .item-table-wrapper {
      display: flex;
      flex-direction: column;
      height: 100%;

      & > .skeleton-content {
        flex: 0 1 auto;
      }

      & > :not(.skeleton-content) {
        flex: 1 1 auto;

        table {
          height: 100%;
        }
      }
    }
  }

  & > :deep(.see-all) {
    flex: 0 1 auto;
  }

  :deep(.overflow-x-scroll) {
    overflow-x: auto !important;
  }
}

:deep(td span) {
  min-width: 0px !important;
}
</style>
